/* import __COLOCATED_TEMPLATE__ from './fixed-string-component-configs.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();